import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField
} from "@mui/material";
import axios from "axios";
import {createForm} from "rc-form";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import { DatePicker } from "@mui/lab";

interface ABVersions {
    name: string;
    quantity: number;
}

interface NewFileSate {
    visible: boolean;
    errors: any;
    creatingInProgress: boolean;
    versions: ABVersions[];
}

interface NewFileProps {
    form: any;
    activeEnv: any;
    refreshData(): void;
    type: "new" | "edit";
    defaultValues: any;
    roles: string[];
}

class GameGeneralEventCreateWrapped extends React.Component<NewFileProps, NewFileSate> {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            errors: {},
            creatingInProgress: false,
            versions: Object.keys(props.defaultValues?.pending || {}).map((key) => ({
                name: key,
                quantity: props.defaultValues.pending[key],
            })),
        };
    }

    onModalClose() {
        this.setState({visible: false});
    }

    checkValidEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    onModalAccept() {
        const {form} = this.props;

        form.validateFields((err, values) => {
            console.log(2233, values);
            if (err) {
                this.setState({errors: err});
                alert(`Please check data input!`);
                return;
            }
            
            this.setState({creatingInProgress: true}, async () => {
                try {
                    console.log(1122, values);
                    const response = await axios.post(`${Config.getInstance.apiUrl}/api/game_general_event/create-or-update`, {
                        ...values,
                        type: this.props.type,
                        id: this.props.defaultValues?.id,
                    }, {
                        headers: {
                            Authorization: Helpers.getSessionId(),
                        },
                    });
                    this.props.refreshData();
                    this.setState({creatingInProgress: false, visible: false});
                } catch (error) {
                    this.setState({creatingInProgress: false});
                    console.error(111, error);

                    PopupMessage.error("Something went wrong!");
                }
            });
        });
    }

    showModal() {
        this.setState({visible: true});
    }
    
    getButton(type: "new" | "edit") {
        const types = {
            new: {name: "Add New"},
            edit: {name: "Edit"},
        };

        return <Button disableElevation variant="contained" color="primary" size="small" onClick={() => this.showModal()}>
            {types[type].name}
        </Button>;
    }

    handleChangeTime = (key: string, value: any) => {
        const form = this.props.form;
        form.setFieldsValue({key: value});
    }

    handleChangeCheckbox = (key: string, value: any) => {
        const checked = value.target.checked;
        this.props.form.setFieldsValue({ key: checked });
    }

    render() {
        const {getFieldDecorator, getFieldError} = this.props.form;

        return (
            <React.Fragment>
                {this.getButton(this.props.type)}

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Dialog
                        open={this.state.visible}
                        onClose={() => this.onModalClose()}
                        aria-labelledby="alert-dialog-title"
                        fullWidth={true}
                        maxWidth="md"
                    >
                        <DialogTitle id="alert-dialog-title">Make new General Event</DialogTitle>
                        <DialogContent style={{paddingTop: 10}}>
                            <Grid container spacing={3} className="marginBottom--none">
                                <Grid item xs={6}>
                                    {getFieldDecorator("eventName",
                                        {
                                            rules: [{
                                                required: true,
                                                message: "Please enter event's name!",
                                            }],
                                            initialValue: this.props.defaultValues?.name || "",
                                        },
                                    )(
                                        <TextField
                                            label="event's name"
                                            style={{width: "100%"}}
                                            error={getFieldError("eventname")}
                                            helperText={getFieldError("eventname") ? getFieldError("eventname").join(",") : null}
                                            size="small"
                                        />,
                                    )}
                                </Grid>

                                <Grid item xs={3}>
                                    {
                                        getFieldDecorator("startDate",
                                            {
                                                rules: [{
                                                    required: true,
                                                    message: "Please enter start date!",
                                                }],
                                                initialValue: this.props.defaultValues?.start_date ?? new Date(),
                                            }
                                        )(
                                            <DatePicker
                                                label="Start Date"
                                                onChange={(e) => this.handleChangeTime("startDate", e)}
                                                renderInput={(params) => <TextField {...params} size="small" />}
                                            />  
                                        )
                                    }
                                </Grid>

                                <Grid item xs={3}>
                                    {getFieldDecorator("endDate",
                                        {
                                             rules: [{
                                                    required: true,
                                                    message: "Please enter end date!",
                                                }],
                                                initialValue: this.props.defaultValues?.end_date ?? new Date(),
                                        }
                                    )(
                                        <DatePicker
                                            label="End Date"
                                            onChange={(e) => this.handleChangeTime("endDate", e)}
                                            renderInput={(params) => <TextField {...params} size="small" />}
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={4}>
                                    {getFieldDecorator("enableEvent",
                                        {
                                            valuePropName: 'checked',
                                            initialValue: this.props.defaultValues?.active ?? false,
                                        }
                                    )(
                                        <Checkbox disabled={this.props.defaultValues.sent_rewards}
                                            //onChange={(e) => this.handleChangeCheckbox("enableEvent", e)}
                                        />
                                    )}
                                    <span style={{ marginLeft: 8 }}>enableEvent</span>
                                </Grid>

                                <Grid item sm={3}>
                                    {getFieldDecorator("rewardsSent",
                                        {
                                            valuePropName: 'checked',
                                            initialValue: this.props.defaultValues?.sent_rewards ?? false,
                                        }
                                    )(
                                        <Checkbox disabled
                                        />
                                    )}
                                    <span style={{ marginLeft: 8 }}>All rewards sent</span>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                disableElevation
                                onClick={() => this.onModalClose()}
                                disabled={this.state.creatingInProgress}
                                size="small"
                                variant="outlined"
                                style={{marginRight: 10}}
                            >
                                Cancel
                            </Button>

                            <div className="loading--button-wrapper">
                                <Button
                                    disableElevation
                                    onClick={() => this.onModalAccept()}
                                    color="primary"
                                    disabled={this.state.creatingInProgress}
                                    size="small"
                                    variant="contained"
                                >
                                    Save
                                </Button>

                                {this.state.creatingInProgress && <CircularProgress size={24} className="loading--button-progress" />}
                            </div>
                        </DialogActions>
                    </Dialog>
                </LocalizationProvider>
            </React.Fragment>
        );
    }
}

export const GameGeneralEventCreate = createForm()(GameGeneralEventCreateWrapped);
